export enum internetPackageTypes {
  Time = "TIME" ,
  Volume = "VOLUME"
}
type StateType = {
  config: Array<any>;
  global: {
    operator: string;
    price: number;
    discountCheckbox: string;
    simcard_type: string;
    package_type ?: "TIME" | "VOLUME",
    receipt: { [key: string]: any };
    token: string;
    coupon: string;
    mobile: string;
    confirmSection: boolean;
    error?: string;
  };
};

export const initialState: StateType = {
  config: [],
  global: {
    operator: "mtn",
    price: 50000,
    discountCheckbox: "",
    simcard_type: "",
    receipt: {},
    token: "",
    coupon: "",
    mobile: "",
    confirmSection: false,
    error: ""
  }
};
export const reducer = (state: StateType, action: any) => {
  switch (action.type) {
    case "ADD_MOBILE":
      return {
        ...state,
        global: {
          ...state.global,
          mobile: action.value
        }
      };
    case "SET_CONFIG":
      return {
        ...state,
        config: action.value,
      };
    case "SET_TYPE":
      return {
        ...state,
        global: {
          ...state.global,
          simcard_type: action.value,
        },
      };
    case "SET_OPERATOR":
      return {
        ...state,
        global: {
          ...state.global,
          operator: action.value,
        },
      };
    case "SET_CONFIRM_SECTION":
      return {
        ...state,
        global: {
          ...state.global,
          confirmSection: action.value,
        },
      };
    case "SET_PRICE":
      return {
        ...state,
        global: {
          ...state.global,
          price: action.value,
        },
      };
    case "SET_COUPON":
      return {
        ...state,
        global: {
          ...state.global,
          coupon: action.value,
        },
      };
    case "SET_DISCOUNT":
      return {
        ...state,
        global: {
          ...state.global,
          discountCheckbox: action.value,
        },
      };
    case "SET_RECEIPT":
      return {
        ...state,
        global: {
          ...state.global,
          receipt: action.vlue
        }
      };
    case "SET_TOKEN":
      return {
        ...state,
        global: {
          ...state.global,
          token: action.lue
        }
      };
    case "SET_ERROR":
      return {
        ...state,
        global: {
          ...state.global,
          error: action.lue
        }
      };

    default:
      throw new Error("Unexpected action");
  }
};
